/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @version 1.3.2
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';
import * as skeleton from '../skeletonConfiguration';
import { ISkeletonStyled } from '../skeletonTypes';
import { LoaderAnimation } from './SkeletonStyled';

interface ISkeletonChartStyled extends ISkeletonStyled {
    multiple: number;
}

export const SkeletonChartStyled = styled(LoaderAnimation).attrs({
    className: 'skeleton__chart',
})<ISkeletonStyled>`
    position: relative;
    width: ${skeleton.width};
    height: ${skeleton.height};
    animation-name: ${skeleton.animationName};
    animation-duration: ${skeleton.animationDuration};
    background: ${colors.skeletonBgLoader};
    border-radius: ${skeleton.buttonBorderRadius};
`;

export const SkeletonChartCenterStyled = styled.div.attrs({
    className: 'skeleton__chart__center',
})<ISkeletonChartStyled>`
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    width: calc(${skeleton.width} * ${props => props.multiple});
    height: calc(${skeleton.height} * ${props => props.multiple});
    background: ${colors.skeletonChartCenterBg};
    border-radius: ${skeleton.buttonBorderRadius};
`;
